<script>
  import { createEventDispatcher } from 'svelte';
  import { goto } from '$app/navigation';

  const dispatch = createEventDispatcher();
  const SLOTS = $$props.$$slots || {};

  export let text = '';
  export let href = '#';
  export let newTab = false;
  export let style;

  let click = function () {
    if (href != '#') {
      if (newTab) {
        window.open(href);
      } else {
        goto(href);
      }
    } else {
      dispatch('click');
    }
  };
</script>

<style style="text/scss" lang="scss">
  a {
    color: #8e71ff;

    &:hover {
      color: #7054dc;
    }
  }
</style>

<a style={style} href={href} class={$$props.class} on:click|preventDefault|stopPropagation={click}>
  {#if text}
    {@html text}
  {:else if SLOTS.content}
    <slot name="content" />
  {/if}
</a>
